module.exports = "https://cdn.redage.net/src/views/player/help/images/electric2.jpg";